/* eslint-disable no-param-reassign */
import { defaultLanguage } from './appConfig'

export const notEmpty = (value) => {
  return value !== null && value !== undefined
}

export const ContentParser = (content, label) => {
  return Object.values(
    Object.keys(content)
      .filter((key) => key.includes(label))
      ?.reduce((obj, key) => {
        return Object.assign(obj, { [key]: content[key] })
      }, {}),
  ).filter(notEmpty)
}

export const getHexadecimal = (number) => {
  const hex = number.toString(16)
  return hex.length === 1 ? `0${hex}` : hex
}

export const otherThanNull = (arr) => {
  return arr.filter((el) => el !== null)
}

export const hasNulls = (arr) => {
  return arr.some((el) => el === null)
}

export const fromStringToNumber = (str) => {
  return parseFloat(str)
}

export const fromRTFtoString = (rtf) => {
  rtf = rtf.replace(/\\par[d]?/g, '')
  return rtf
    .replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '')
    .trim()
    .replace(/<[^>]*>?/gm, '')
}

export function sortArrayByAnotherArray(objectsArray, stringsArray) {
  return objectsArray
    .map((obj) => ({ ...obj, index: stringsArray.indexOf(obj.heading) }))
    .sort((a, b) => a.index - b.index)
    .map((obj) => {
      delete obj.index
      return obj
    })
}

export const getUniqueValues = (arr) => {
  return [...new Set(arr)]
}

export const getUniqueValuesFromArrayOfObjects = (arr, key) => {
  return [...new Set(arr.map((obj) => obj[key]))]
}

export const getUniqueValuesFromArrayOfArrays = (arr) => {
  return [...new Set(arr.flat())]
}

export const ALLOWED_WORDS = {
  en: 'Muscle Relaxants',
  nl: 'Spierontspanners',
}

export function replaceWordInString(str, oldWord, newWord) {
  if (!str) return str
  const regex = new RegExp(`\\b${oldWord}\\b`, 'gi')
  return str.replace(regex, newWord)
}

export const isDefualtLanguage = (lang) => lang === defaultLanguage.slice(0, 2)

export function findMatchingItems(components, data, sectionsPresets) {
  return data.filter((item) => {
    return (
      components.includes(item.nodeType) &&
      Object.prototype.hasOwnProperty.call(sectionsPresets, item.nodeType) &&
      Object.prototype.hasOwnProperty.call(
        item,
        sectionsPresets[item.nodeType],
      ) &&
      item[sectionsPresets[item.nodeType]].hasowndata
    )
  })
}
